import useFeatureFlags from 'hooks/useFeatureFlags'
import StockDiscrepanciesReportScreen from './StockDiscrepanciesReportScreen'
import { StockDiscrepanciesReportScreenV2 } from '../../Residents/screens/ResidentEmarV2Screens/StockDiscrepanciesReportV2'

const StockDiscrepanciesReportScreenWrapper = () => {
  const flags = useFeatureFlags({ flagNames: ['emar_v2_stock'] })?.data

  const newEmarEnabled = flags?.emar_v2_stock?.enabled ?? false

  if (newEmarEnabled) {
    return <StockDiscrepanciesReportScreenV2 />
  }

  return <StockDiscrepanciesReportScreen />
}

export default StockDiscrepanciesReportScreenWrapper
